import { gql } from "@apollo/client";

/**
 * @deprecated Shared fragments are deprecated. Indicate field name directly within query/mutation or
 * create a co-located (not shared) fragment, if you need one.
 */
const STORE_FRAGMENT = gql`
  fragment StoreFragment on Store {
    id

    createdAt
    updatedAt
    discount
    marginType
    accountModality
    freePriorityShipping
    hasGlobalPatientAccess
    name
    slug
    storeOwnerName
    currentSetupPage
    isCheckoutEnabled
    referralLink
    hasAdvancedSecurity
  }
`;

/**
 * @deprecated Shared fragment types are deprecated. Use or pick from generated types instead.
 */
interface StoreFragment {
  id: string;

  createdAt: string;
  updatedAt: string;
  discount: number;
  marginType: string;
  accountModality: string;
  freePriorityShipping: boolean;
  hasGlobalPatientAccess: boolean;
  name: string;
  slug: string;
  storeOwnerName: string;
  currentSetupPage: string;
  isCheckoutEnabled: boolean;
  referralLink: string;
  hasAdvancedSecurity: boolean;
}

export type { StoreFragment };
export { STORE_FRAGMENT };
